import React, { FC } from 'react'

import { ContentSeparator } from '@components'
import { ReactComponent as Logo } from './assets/akili_logo.svg'
import styles from './styles.module.scss'

export enum HeaderDescriptionTypeEnum {
  String,
  NewLine,
  Link
}
type DescriptionType = {
  type: HeaderDescriptionTypeEnum
  content?: string
  href?: string
  target?: string
}
type HeaderProps = { title?: string; description: string | DescriptionType[] }

const Description = (descriptionType: DescriptionType) => {
  let result
  switch (descriptionType.type) {
    case HeaderDescriptionTypeEnum.Link:
      result = (
        <a href={descriptionType.href} target={descriptionType.target}>
          {descriptionType.content}
        </a>
      )
      break
    case HeaderDescriptionTypeEnum.NewLine:
      result = <br />
      break
    case HeaderDescriptionTypeEnum.String:
      result = descriptionType.content
      break
    default:
      break
  }
  return result
}

const Header: FC<HeaderProps> = ({ title, description }) => {
  return (
    <div className={styles.header}>
      <div>
        <Logo />
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>
        {typeof description === 'string'
          ? description
          : description.map((type) => Description(type))}
      </div>
      <ContentSeparator extraClassName={styles.separator} />
    </div>
  )
}

export default Header
